const OpenCookieBanner = {
  init: () => {
    const elements = document.querySelectorAll('a[data-event-id="cookie-consent"]');

    elements.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        window.tC?.privacyCenter.showPrivacyCenter();
      });
    });

    const handleMutation = function (mutationsList: MutationRecord[]) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const addedNodes: NodeList = mutation.addedNodes;
          for (const addedNode of addedNodes) {
            if (addedNode instanceof Element && addedNode.id === 'tc-privacy-wrapper') {
              const popinTcPrivacy = document.getElementById('popin_tc_privacy');
              if (popinTcPrivacy) {
                popinTcPrivacy.classList.add('popin-custom-wrapper');
                observer.disconnect();
              }
            }
          }
        }
      }
    };

    const observer = new MutationObserver(handleMutation);
    observer.observe(document.body, {
      childList: true,
    });
  },
};

export default OpenCookieBanner;
